import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Google } from "@mui/icons-material";
import { useAuth } from "@/context/AuthContext";
import { useNotification } from "@/context/NotificationContext";
import BrandMark from "@/components/BrandMark";
import LanguageThemeControls from "@/components/LanguageThemeControls";

export default function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, loginWithGoogle } = useAuth();
  const { notify } = useNotification();

  useEffect(() => {
    if (searchParams.get("error") === "auth_failed") {
      notify(t("common.error"), "error");
    }
  }, [searchParams, notify, t]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        p: 3,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          display: "flex",
          gap: 1,
        }}
      >
        <LanguageThemeControls variant="login" />
      </Box>
      <Paper
        sx={{
          p: 6,
          borderRadius: 3,
          textAlign: "center",
          maxWidth: 400,
          width: "100%",
        }}
      >
        <Box sx={{ mx: "auto", mb: 3, display: "flex", justifyContent: "center" }}>
          <BrandMark size={56} fontSize={24} borderRadius={2} />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mb: 1,
          }}
        >
          {t("app.title")}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 4,
          }}
        >
          {t("app.subtitle")}
        </Typography>

        <Button
          variant="contained"
          size="large"
          fullWidth
          startIcon={<Google />}
          onClick={loginWithGoogle}
        >
          {t("auth.signInWithGoogle")}
        </Button>
      </Paper>
    </Box>
  );
}
